import {connect} from 'formik'
import {FormikCents, PaypalButton} from './'
import {Button} from 'shared'

export const SubmitButton = connect(({formik}) => {

  if (formik.values.payment_method === 'paypal') {
    return <PaypalButton/>
  }

  const loading = formik.isSubmitting || formik.values._redirecting
  const classNames = 'btn-large btn-primary submit-donation-button'

  if (formik.values.payment_method === 'direct_deposit' ) {
    return (
      <Button loading={loading} className={classNames}>
        { I18n.t('donate.submit_button.direct_deposit') }
      </Button>
    )
  }

  return (
    <Button loading={loading} className={classNames}>
      { I18n.t('donate.submit_button.default.before_amount') } <FormikCents fields={['amount_cents', 'codonation_cents']} /> { I18n.t('donate.submit_button.default.after_amount') }
    </Button>
  )
})
